import { CheckIcon, WarningIcon } from "@phosphor-icons/react";

export type ToastData = { kind: "success" | "error"; message: string } | null;

export function Toast({ toast }: { toast: ToastData }) {
  if (!toast) return null;
  return (
    <div className={`toast ${toast.kind}`} role="status" aria-live="polite">
      {toast.kind === "success" ? <CheckIcon size={18} weight="bold" /> : <WarningIcon size={18} weight="bold" />}
      <span>{toast.message}</span>
    </div>
  );
}
